/**
 * Cookies this site can leave behind, by name. Google Analytics sets `_ga`, `_ga_<stream>`, `_gid`,
 * `_gat*` (and the old `__utm*` set). `CookieControl*` are the previous consent tool's own, and `rl_*`
 * RudderStack's, from before it was removed; nothing reads either any more.
 */
const OWNED_COOKIE = /^(_ga|_gid|_gat|__utm[a-z]|CookieControl|rl_)/;

const EPOCH = 'Thu, 01 Jan 1970 00:00:00 GMT';

/** The host and each parent domain with at least two labels, since Google sets its cookies on the parent. */
const candidateDomains = (hostname: string): (string | undefined)[] => {
    const labels = hostname.split('.');
    const parents = labels.map((_, i) => labels.slice(i)).filter((rest) => rest.length >= 2);

    return [undefined, ...parents.map((rest) => `.${rest.join('.')}`)];
};

/** Expires the cookies above. Withdrawing consent has to remove what was already stored, not just stop new writes. */
export const clearAnalyticsCookies = (): void => {
    const names = document.cookie
        .split(';')
        .map((cookie) => cookie.split('=')[0].trim())
        .filter((name) => OWNED_COOKIE.test(name));

    names.forEach((name) =>
        candidateDomains(window.location.hostname).forEach((domain) => {
            document.cookie = `${name}=; expires=${EPOCH}; path=/${domain ? `; domain=${domain}` : ''}`;
        }),
    );
};
